module.exports = __webpack_public_path__ + "img/jes.20ebaec2.svg";